module.exports = __webpack_public_path__ + "img/smart_bracelet_watch_2.e147ce48.png";